import "./impressum.css";
import { useState } from "react";
import IframeWindow from "./IframeWindow.jsx";

// Nur für den Startbildschirm gedacht (gerendert in LoadingBar.jsx).
// Bewusst mit LOKALEM State statt stateIframeWindow: der globale Iframe wird
// vom UiManager gerendert und liegt unter dem Startscreen (z-index 200), und
// sein Schließen würde playerInput=true setzen — also den Spieler hinter dem
// noch sichtbaren Ladescreen freischalten.
const Impressum = () => {
  const [showImpressum, setShowImpressum] = useState(false);

  return (
    <>
      <div className="impressumText" onClick={() => setShowImpressum(true)}>
        impressum
      </div>

      {showImpressum && (
        <div className="impressumIframeLayer">
          <IframeWindow
            src="./impressum/index.html"
            onClose={() => setShowImpressum(false)}
          />
        </div>
      )}
    </>
  );
};

export default Impressum;
